<template>
  <div class="home">
    <!-- header -->
    <div class="header hidden-xs-only">
      <div class="header_box section">
        <div class="header_left">
          <img src="../assets/images/logo.png" />
        </div>
        <div class="header_right">
          <div class="header_right_item" @click="changeLanguage">
            <div class="header_right_item_left">
              <img src="../assets/images/chinese.png" alt="">
            </div>
            <div class="header_right_item_right">中文版</div>
          </div>
          <div class="header_right_line"></div>
          <div class="header_right_item">
            <div class="header_right_item_left">
              <img src="../assets/images/english_active.png" alt="">
            </div>
            <div class="header_right_item_right header_right_item_eng">ENGLISH</div>
          </div>
        </div>
      </div>
    </div>
    <!-- menu_mobile -->
    <div class="menu_mobile hidden-sm-and-up">
      <div class="menu_mobile_box section">
        <div class="menu_mobile_box_box">
          <div class="menu_mobile_left">
            <img src="../assets/images/logo.png" alt="">
          </div>
          <div class="menu_mobile_right" @click="openMenuMobile">
            <img src="../assets/images/menu.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <!-- 导航栏 -->
    <div class="menu hidden-xs-only">
      <div class="menu_box section">
        <div class="menu_item" :class="{active:indexActive}" @click="goOtherPath('/index_en')">Home</div>
        <div class="menu_item" :class="{active:allianceActive}" @click="goOtherPath('/about_en')">About Us</div>
        <div class="menu_item" :class="{active:memberActive}" @click="goOtherPath('/member_en')">Member Area</div>
        <div class="menu_item" :class="{active:newsActive}" @click="goOtherPath('/news_en')">News</div>
        <div class="menu_item" @click="goOtherPath('/conference_en')">Exhibition Information</div>
        <div class="menu_item" :class="{active:certificationActive}" @click="goOtherPath('/certification_en')">Standard Certification</div>
        <div class="menu_item web_link" @click="goWeb('http://foodtrust.cafa.org.cn/')">Food Trust Traceability Platform</div>
        <div class="menu_item" :class="{active:workActive}" @click="goOtherPath('/work_en')">Party Building Work</div>
        <div class="menu_item" :class="{active:contactActive}" @click="goOtherPath('/contact_en')">Contact Us</div>
      </div>
    </div>
    <!-- banner -->
    <div class="banner">
      <div class="banner_box">
        <div class="index_banner" v-if="$route.name == 'index_en'">
          <el-carousel trigger="click" autoplay pause-on-hover>
              <el-carousel-item v-for="(item,index) in indexBannerList" :key="index">
                  <img @click="goNewsDetail(item)" v-if="item.picture" :src="baseUrl+item.picture" alt="">
              </el-carousel-item>
          </el-carousel>
        </div>
        <div class="other_banner" v-else>
          <img src="../assets/images/index/other_banner.png" alt="">
          <div class="other_banner_text">{{$route.meta.title}}</div>
        </div>
      </div>
    </div>
    <div class="main">
      <router-view :key="$route.fullPath"></router-view>
    </div>
    <!-- footer -->
    <div class="footer hidden-xs-only">
      <div class="footer_top">
        <div class="footer_top_box section">
          <div class="footer_top_left">
            <div class="footer_top_left_img">
              <img src="../assets/images/index/footer_link.png" alt="">
            </div>
            <div class="footer_top_left_text">Links：</div>
          </div>
          <div class="footer_top_right">
            <div class="footer_top_right_item" v-for="(item,index) in linkList" :key="index">
              <div class="footer_top_right_item_name" @click="goWeb(item.path)">{{item.name}}</div>
              <div class="footer_top_right_item_line"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer_bottom">
        <div class="footer_bottom_box section">
          <div class="footer_bottom_top">
            <div class="footer_bottom_top_item">
              <div class="footer_bottom_top_item_top" @click="goOtherPath('/about_en')">About Us</div>
              <div class="footer_bottom_top_item_box">
                <div class="footer_bottom_top_item_box_item" @click="goPageItem('/about_en',item)" v-for="(item,index) in alliance" :key="index">{{item.typeName}}</div>
              </div>
            </div>
            <div class="footer_bottom_top_item">
              <div class="footer_bottom_top_item_top" @click="goOtherPath('/member_en')">Member Area</div>
              <div class="footer_bottom_top_item_box">
                <div class="footer_bottom_top_item_box_item" @click="goPageItem('/member_en',item)" v-for="(item,index) in memberTypeList" :key="index">{{item.typeName}}</div>
              </div>
            </div>
            <div class="footer_bottom_top_item">
              <div class="footer_bottom_top_item_top" @click="goOtherPath('/news_en')">News</div>
              <div class="footer_bottom_top_item_box">
                <div class="footer_bottom_top_item_box_item" @click="goPageItem('/news_en',item)" v-for="(item,index) in newsTypeList" :key="index">{{item.typeName}}</div>
              </div>
            </div>
            <div class="footer_bottom_top_item">
              <div class="footer_bottom_top_item_top" @click="goOtherPath('/conference_en')">Exhibition Information</div>
              <div class="footer_bottom_top_item_item" @click="goOtherPath('/certification_en')">Standard Certification</div>
              <div class="footer_bottom_top_item_item" @click="goWeb('http://foodtrust.cafa.org.cn/')">Food Trust Traceability Platform</div>
              <div class="footer_bottom_top_item_item" @click="goOtherPath('/work_en')">Party Building Work</div>
            </div>
            <div class="footer_bottom_top_item footer_bottom_top_contact">
              <div class="footer_bottom_top_item_top">Telephone</div>
              <div class="footer_bottom_top_item_phone">
                <div class="footer_bottom_top_item_phone_left">
                  <img src="../assets/images/index/footer_phone.png" alt="">
                </div>
                <div class="footer_bottom_top_item_phone_right timeFont">010-53609609</div>
              </div>
              <div class="footer_bottom_top_item_line"></div>
              <div class="footer_bottom_top_item_bottom">
                <div class="footer_bottom_top_item_bottom_item">North Office Area, Ministry of Agriculture and Rural Affairs, Maizidian Street, Chaoyang District, Beijing</div>
                <div class="footer_bottom_top_item_bottom_item_two">Room 413, building 24</div>
              </div>
            </div>
            <div class="footer_bottom_top_item">
              <div class="footer_bottom_top_right_right_box">
                <img src="../assets/images/index/footer_code.png" alt="">
              </div>
            </div>
          </div>
          <div class="footer_bottom_bottom">
            <div class="footer_bottom_bottom_item">Copyright：National animal health and Food Safety Innovation Alliance All Rights Reserved </div>
            <div class="footer_bottom_bottom_item" @click="goWeb('https://beian.miit.gov.cn/#/Integrated/index')">Beijing ICP No.20012509-2</div>
          </div>
        </div>
      </div>
    </div>
    <!-- mobile_footer -->
    <div class="mobile_footer hidden-sm-and-up">
      <div class="mobile_footer_link">
        <div class="section">
          <div class="link_top">
            <div class="link_top_box">
              <div class="link_top_left">
                <img src="../assets/images/index/footer_link.png" alt="">
              </div>
              <div class="link_top_right">Links：</div>
            </div>
          </div>
          <div class="link_bottom">
            <div class="footer_top_right_item" v-for="(item,index) in linkList" :key="index">
              <div class="footer_top_right_item_name" @click="goWeb(item.path)">{{item.name}}</div>
              <div class="footer_top_right_item_line"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="mobile_footer_menu">
        <div class="mobile_footer_menu_box section">
          <div class="mobile_footer_menu_top">
            <el-collapse v-model="activeNames">
              <el-collapse-item title="About Us" name="1">
                <div @click="goPageItem('/about_en',item)" v-for="(item,index) in alliance" :key="index">{{item.typeName}}</div>
              </el-collapse-item>
              <el-collapse-item title="Member Area" name="2">
                <div @click="goPageItem('/member_en',item)" v-for="(item,index) in memberTypeList" :key="index">{{item.typeName}}</div>
              </el-collapse-item>
              <el-collapse-item title="news" name="3">
                <div @click="goPageItem('/news_en',item)" v-for="(item,index) in newsTypeList" :key="index">{{item.typeName}}</div>
              </el-collapse-item>
            </el-collapse>
          </div>
          <div class="mobile_footer_menu_middle">
            <div class="mobile_footer_menu_middle_item" @click="goOtherPath('/conference_en')">Exhibition Information</div>
            <div class="mobile_footer_menu_middle_item" @click="goOtherPath('/certification_en')">Standard Certification</div>
            <div class="mobile_footer_menu_middle_item" @click="goWeb('http://foodtrust.cafa.org.cn/')">Food Trust Traceability Platform</div>
            <div class="mobile_footer_menu_middle_item" @click="goOtherPath('/work_en')">Party Building Work</div>
          </div>
          <div class="mobile_footer_menu_contact">
            <div class="mobile_footer_menu_contact_left">
              <div class="mobile_footer_menu_contact_top">Telephone</div>
              <div class="mobile_footer_menu_contact_middle">
                <div class="mobile_footer_menu_contact_middle_left">
                  <img src="../assets/images/index/footer_phone.png" alt="">
                </div>
                <div class="mobile_footer_menu_contact_middle_right timeFont">010-53609609</div>
              </div>
              <div class="mobile_footer_menu_contact_bottom">North Office Area, Ministry of Agriculture and Rural Affairs, Maizidian Street, Chaoyang District, Beijing Room 413, building 24</div>
            </div>
            <div class="mobile_footer_menu_contact_right">
              <div class="mobile_footer_menu_contact_right_box">
                <img src="../assets/images/index/footer_code.png" alt="">
              </div>
            </div>
          </div>
          <div class="mobile_footer_menu_bottom">
            <div class="mobile_footer_menu_bottom_item mobile_footer_menu_bottom_first">Copyright：National animal health and Food Safety Innovation Alliance All Rights Reserved </div>
            <div class="mobile_footer_menu_bottom_item" @click="goWeb('https://beian.miit.gov.cn/#/Integrated/index')">Beijing ICP No.20012509-2</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 手机端菜单 -->
    <el-drawer
      title="导航栏"
      size="68%"
      :visible.sync="isOpenMenuMobile"
      :with-header="false"
      :before-close="handleClose">
      <div class="mobile_menu_box">
        <div class="mobile_menu_box_top">
          <i class="el-icon-close" @click="handleClose"></i>
        </div>
        <div class="mobile_menu_box_bottom">
          <div class="mobile_menu_box_bottom_bottom">
            <div class="menu_item" :class="{active:indexActive}" @click="goOtherPath('/index_en')">Home</div>
            <div class="menu_item" :class="{active:allianceActive}" @click="goOtherPath('/about_en')">About Us</div>
            <div class="menu_item" :class="{active:memberActive}" @click="goOtherPath('/member_en')">Member Area</div>
            <div class="menu_item" :class="{active:newsActive}" @click="goOtherPath('/news_en')">News</div>
            <div class="menu_item" @click="goOtherPath('/conference_en')">Exhibition Information</div>
            <div class="menu_item" :class="{active:certificationActive}" @click="goOtherPath('/certification_en')">Standard Certification</div>
            <div class="menu_item web_link" @click="goWeb('http://foodtrust.cafa.org.cn/')">Food Trust Traceability Platform</div>
            <div class="menu_item" :class="{active:workActive}" @click="goOtherPath('/work_en')">Party Building Work</div>
            <div class="menu_item" :class="{active:contactActive}" @click="goOtherPath('/contact_en')">Contact Us</div>
          </div>
          <div class="mobile_menu_box_bottom_top">
            <div class="mobile_menu_box_bottom_top_item" @click="changeLanguage">中文版</div>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import $ from 'jquery'
import { newsTypeList,newsList } from '../untils/common-api.js'
export default {
  data() {
    return {
      indexActive:false,
      allianceActive:false,
      memberActive:false,
      newsActive:false,
      certificationActive:false,
      workActive:false,
      contactActive:false,
      baseUrl: process.env.VUE_APP_BASE_URL,
      indexBannerList:[],
      linkList:[
        {
          id:1,
          name:'Agriculture and rural sector',
          path:'http://www.moa.gov.cn/'
        },
        {
          id:2,
          name:'National Animal Husbandry Station',
          path:'http://www.nahs.org.cn/'
        },
        {
          id:3,
          name:'National Agricultural Science and Technology Innovation Alliance',
          path:'http://nastia.caas.cn/'
        },
        {
          id:4,
          name:'Chinese Academy of Agricultural Sciences',
          path:'http://www.caas.net.cn/'
        },
        {
          id:5,
          name:'China Animal Disease Control Center',
          path:'http://www.cadc.net.cn/'
        },
        {
          id:6,
          name:'China Veterinary Drug Administration',
          path:'http://www.ivdc.org.cn/'
        },
        {
          id:7,
          name:'China animal health and Epidemiology Center',
          path:'http://www.cahec.cn/'
        },
      ],
      // 关于联盟
      alliance:[],
      // 成员单位
      memberTypeList:[],
      // 新闻动态
      newsTypeList:[],

      // 手机端
      isOpenMenuMobile:false,
      activeNames: []
    }
  },
  // 监听路由是否发生了改变
  watch:{
      $route(to,from){
        if(to.params.name) {
          let path = ''
          if(to.params.name == 'about_en') {
            path = '/about_en'
          } else if(to.params.name == 'member_en') {
            path = '/member_en'
          } else if(to.params.name == 'news_en') {
            path = '/news_en'
          } else if(to.params.name == 'certification_en') {
            path = '/certification_en'
          } else if(to.params.name == 'work_en') {
            path = '/work_en'
          } else if(to.params.name == 'brand_en') {
            path = '/brand_en'
          } else if(to.params.name == 'books_en') {
            path = '/books_en'
          }
          this.changeNavStyle(path);
        } else {
          this.changeNavStyle(to.path);
        }
      }
  },
  created() {
    if(this.$route.params.name) {
      let path = ''
      if(this.$route.params.name == 'about_en') {
        path = '/about_en'
      } else if(this.$route.params.name == 'member_en') {
        path = '/member_en'
      } else if(this.$route.params.name == 'news_en') {
        path = '/news_en'
      } else if(this.$route.params.name == 'certification_en') {
        path = '/certification_en'
      } else if(this.$route.params.name == 'work_en') {
        path = '/work_en'
      } else if(this.$route.params.name == 'brand_en') {
        path = '/brand_en'
      } else if(this.$route.params.name == 'books_en') {
        path = '/books_en'
      }
      this.changeNavStyle(path);
    } else {
      this.changeNavStyle(this.$route.path);
    }
    // 关于联盟
    this.getAllianceTypeList(1)
    // 新闻动态
    this.getNewsTypeList(2)
    this.getMemberTypeList(7)
    this.getIndexBanner()
    // this.getNewsList()
  },
  methods: {
    changeLanguage() {
      this.$router.push({ name: 'index' })
    },
    changeNavStyle(url){
        switch (url) {
            case "/index_en":
                    this.indexActive=true;
                    this.allianceActive=false;
                    this.memberActive=false;
                    this.newsActive=false;
                    this.certificationActive=false;
                    this.workActive=false;
                    this.contactActive=false;
                break;
            case "/about_en":
                     this.indexActive=false;
                     this.allianceActive=true;
                     this.memberActive=false;
                     this.newsActive=false;
                     this.certificationActive=false;
                     this.workActive=false;
                     this.contactActive=false;
                break;
            case "/member_en":
                     this.indexActive=false;
                     this.allianceActive=false;
                     this.memberActive=true;
                     this.newsActive=false;
                     this.certificationActive=false;
                     this.workActive=false;
                     this.contactActive=false;
                break;
            case "/news_en":
                     this.indexActive=false;
                     this.allianceActive=false;
                     this.memberActive=false;
                     this.newsActive=true;
                     this.certificationActive=false;
                     this.workActive=false;
                     this.contactActive=false;
                break;
            case "/certification_en":
                     this.indexActive=false;
                     this.allianceActive=false;
                     this.memberActive=false;
                     this.newsActive=false;
                     this.certificationActive=true;
                     this.workActive=false;
                     this.contactActive=false;
                break;
            case "/work_en":
                     this.indexActive=false;
                     this.allianceActive=false;
                     this.memberActive=false;
                     this.newsActive=false;
                     this.certificationActive=false;
                     this.workActive=true;
                     this.contactActive=false;
                break;
            case "/contact_en":
                     this.indexActive=false;
                     this.allianceActive=false;
                     this.memberActive=false;
                     this.newsActive=false;
                     this.certificationActive=false;
                     this.workActive=false;
                     this.contactActive=true;
                break;
            case "/brand_en":
            case "/books_en":
                     this.indexActive=false;
                     this.allianceActive=false;
                     this.memberActive=false;
                     this.newsActive=false;
                     this.certificationActive=false;
                     this.workActive=false;
                     this.contactActive=false;
                break;
            default:
                     this.indexActive=false;
                     this.allianceActive=false;
                     this.memberActive=false;
                     this.newsActive=false;
                     this.certificationActive=false;
                     this.workActive=false;
                     this.contactActive=false;
        }
    },
    // 图片新闻
    async getIndexBanner(id) {
      const res = await newsList (
        {
          current:1,
          pageSize:-1,
          newsType:id,
          model:2,
          lang:2,
        }
      )
      if(res.code ==1) {
        this.indexBannerList = res.data.records
      }
    },
    goNewsDetail(item) {
      if(item.link) {
          if(item) {
              // 打开新页面
              window.open(item.link, '_blank');
          }
      } else {
          this.$router.push({name: 'details_en', params: { name: 'news_en', type: item.newsType, id: item.id,current:1 } })
      }
    },
    // 关于联盟分类
    async getAllianceTypeList(num) {
      let res = await newsTypeList(
        {
          model:num,
          lang:2
        }
      )
      if (res.code !== 1) return this.$message('Information retrieval failed. Please try again later')
      this.alliance = res.data.records
    },
    // 获取新闻分类
    async getNewsTypeList(num) {
      let res = await newsTypeList(
        {
          model:num,
          lang:2
        }
      )
      if (res.code !== 1) return this.$message('Information retrieval failed. Please try again later')
      this.newsTypeList = res.data.records
      let list  = res.data.records
      if(list.length > 0) {
        let newsItem = list.find(item => item.typeName == 'Picture News')
        if(newsItem) {
          let id = newsItem.id
          this.getIndexBanner(id)
        }
      }
    },
    // 获取成员单位分类
    async getMemberTypeList(num) {
      let res = await newsTypeList(
        {
          model:num,
          lang:2
        }
      )
      if (res.code !== 1) return this.$message('Information retrieval failed. Please try again later')
      this.memberTypeList = res.data.records
    },
    goPageItem(path,item) {
      this.$router.push({ path: path,query:{type:item.id} })
      this.changeNavStyle(path)
    },
    goOtherPath(item) {
      if(item == '/conference_en') {
        return this.$message('Function development is underway, please stay tuned ..')
      }
      if(item) {
        this.handleClose()
        this.$router.push({ path: item })
        this.changeNavStyle(item)
      }
    },
    goWeb(item) {
      if(item) {
        this.handleClose()
        // 打开新页面
        window.open(item, '_blank');
      }
    },
    openMenuMobile() {
      this.isOpenMenuMobile = true;
    },
    handleClose() {
      this.$nextTick(() => {
        this.isOpenMenuMobile = false;
      });
    },
    initDropDown() {
      $('.header_mobile_title span').click(function() {
          if ($('.header_mobile_content')[0].style.display === 'none') {
              $('.header_mobile_content').slideDown(350)
          } else {
              $('.header_mobile_content').slideUp(350)
          }
      })
      $('.header_mobile_content a').click(function() {
          $('.header_mobile_content').hide()
      })
    },
  },
  mounted() {
    document.title = 'National animal health and Food Safety Innovation Alliance'
    this.initDropDown()
  }
}
</script>
<style lang="less" scoped>
.home {
  width: 100%;
  .header {
    width: 100%;
    .header_box {
      height: 104px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .header_left {
        width: 482px;
        height: 72px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .header_right {
        display: flex;
        align-items: center;
        font-size: 16px;
        .header_right_item {
          display: flex;
          align-items: center;
          color: #383838;
          .header_right_item_left {
            display: flex;
            align-items: center;
            margin-right: 10px;
            margin-top: 1.5px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .header_right_item_right{
            color: #787878;
          }
          .header_right_item_eng {
            color: #383838;
          }
        }
        .header_right_line {
          width: 1px;
          height: 15px;
          border-right: 1px solid #383838;
          margin: 0 15px;
        }
        .header_right_item:first-child {
          cursor: pointer;
        }
      }
    }
  }
  .menu {
    width: 100%;
    height: 56px;
    background-color: #0085D0;
    .menu_box {
      height: 100%;
      display: flex;
      justify-content: space-between;
      .menu_item {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 56px;
        width: 10.75%;
        color: #fff;
        font-size: 16px;
        cursor: pointer;
        text-align: center;
      }
      .menu_item:hover {
        color: #fff!important;
        background: #4db62b;
      }
      .web_link {
        width:14% ;
        cursor: pointer;
      }
      .active {
        background: #4db62b;
      }
    }
  }
  .banner {
    width: 100%;
    .banner_box {
      width: 100%;
      .index_banner {
        height: 600px;
        width: 100%;
        /deep/ .el-carousel {
          height: 600px;
          .el-carousel__container {
              height: 600px;
              .el-carousel__item {
                  height: 600px;
                  img {
                      width: 100%;
                      height: 600px;
                      cursor: pointer;
                  }
              }
          }
        }
      }
      .other_banner {
        height: 180px;
        width: 100%;
        position: relative;
        img {
          width: 100%;
          height: 100%;
        }
        .other_banner_text {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%,-50%);
          font-size: 40px;
          font-weight: bold;
          color: #ffffff;
        }
      }
    }
  }
  .footer {
    width: 100%;
    .footer_top {
      background-color: #265ebf;
      color: #ffffff;
      .footer_top_box {
        display: flex;
        .footer_top_left {
          width: 110px;
          display: flex;
          align-items: center;
          padding: 0 0 62px 0;
          .footer_top_left_img {
            width: 28px;
            height: 28px;
            margin-right: 8px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .footer_top_left_text {
            font-size: 20px;
          }
        }
        .footer_top_right {
          width: calc(100% - 110px);
          display: flex;
          flex-wrap: wrap;
          padding: 20px 0 20px 0;
          .footer_top_right_item {
            display: flex;
            align-items: center;
            .footer_top_right_item_name{
              font-size: 16px;
              line-height: 2;
              padding: 0 10px;
              cursor: pointer;
            }
            .footer_top_right_item_line {
              width: 2px;
              height: 14px;
              background-color: #ffffff;
              margin: 0 5px;
            }
          }
          .footer_top_right_item:last-child {
            .footer_top_right_item_line {
              display: none;
            }
          }
        }
      }
    }
    .footer_bottom {
      background-color: #1d2f47;
      color: #ffffff;
      .footer_bottom_box {
        .footer_bottom_top {
          display: flex;
          justify-content: space-between;
          padding: 100px 0 55px 0;
          .footer_bottom_top_item {
            .footer_bottom_top_item_top {
              font-size: 16px;
              font-weight: 600;
              margin-bottom: 20px;
              cursor: pointer;
            }
            .footer_bottom_top_item_box {
              .footer_bottom_top_item_box_item {
                // font-size: 13px;
                margin-bottom: 15px;
                display: flex;
                cursor: pointer;
              }
            }
            .footer_bottom_top_item_item {
              font-size: 16px;
              font-weight: 600;
              margin-bottom: 20px;
              cursor: pointer;
            }
            .footer_bottom_top_item_phone{
              display: flex;
              align-items: center;
              padding-right: 40px;
              .footer_bottom_top_item_phone_left {
                width: 24px;
                height: 24px;
                margin-right: 10px;
                img {
                  width: 100%;
                  height: 100%;
                }
              }
              .footer_bottom_top_item_phone_right {
                font-size: 26px;
              }
            }
            .footer_bottom_top_item_line {
              width: 240px;
              margin: 15px 0;
              border-top: 2px solid rgba(38, 94, 191, 0.3);
            }
            .footer_bottom_top_item_bottom {
              .footer_bottom_top_item_bottom_item {
                margin-bottom: 5px;
              }
            }
            .footer_bottom_top_right_right_box {
              width: 120px;
              height: 120px;
              img {
                width: 100%;
                height: 100%;
              }
            }
          }
          .footer_bottom_top_contact {
            max-width:260px ;
          }
        }
        .footer_bottom_bottom {
          font-size: 16px;
          display: flex;
          justify-content: center;
          padding: 55px 0 100px 0;
          border-top: 2px solid rgba(38, 94, 191, 0.3);
          .footer_bottom_bottom_item {
            margin-right: 40px;
          }
          .footer_bottom_bottom_item:last-child {
            margin-right: 0;
            cursor: pointer;
          }
        }
      }
    }
  }
  .menu_mobile {
    .menu_mobile_box {
      .menu_mobile_box_box {
        padding: 0.2rem 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .menu_mobile_left {
          width: calc(100% - 0.7rem);
          img {
            width: 100%;
            height: 100%;
          }
        }
        .menu_mobile_right {
          width: 0.44rem;
          height: 0.3rem;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
  .mobile_footer {
    .mobile_footer_link {
      background-color: #265ebf;
      padding: 0.3rem 0;
      color: #ffffff;
      .section {
        display: flex;
        .link_top {
          width: 1.55rem;
          display: flex;
          flex-direction: column;
          .link_top_box {
            display: flex;
            align-items: center;
            .link_top_left {
              width: 0.4rem;
              height: 0.4rem;
              margin-right: 0.1rem;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .link_top_right {
              line-height: 2;
            }
          }
        }
        .link_bottom {
          width: calc(100% - 1.55rem);
          display: flex;
          flex-wrap: wrap;
          .footer_top_right_item {
            display: flex;
            align-items: center;
            .footer_top_right_item_name{
              line-height: 2;
              padding: 0 0.1rem;
              cursor: pointer;
            }
            .footer_top_right_item_line {
              width: 0.04rem;
              height: 0.28rem;
              background-color: #ffffff;
              margin: 0 0.05rem;
            }
          }
          .footer_top_right_item:last-child {
            .footer_top_right_item_line {
              display: none;
            }
          }
        }
      }
    }
    .mobile_footer_menu {
      background-color: #1d2f47;
      padding: 0.5rem 0;
      color: #ffffff;
      .mobile_footer_menu_box {
        .mobile_footer_menu_top {
          /deep/ .el-collapse {
              border: none;
              border-top:1px solid #1f3d6c !important;
              .el-collapse-item {
                  background-color: #1d2f47;
                  position: relative;
                  .el-collapse-item__header {
                      height: 1rem;
                      background-color: #1d2f47!important;
                      border-color:#1f3d6c !important;
                      font-size: .3rem;
                      color: #ffffff!important;
                      display: flex;
                      align-items: center;
                      .el-collapse-item__arrow {
                        font-size: .26rem;
                      }
                  }
                  .el-collapse-item__wrap {
                      background-color: #1d2f47!important;
                      border-color:#1f3d6c !important;
                      .el-collapse-item__content {
                          padding-bottom: 0.2rem;
                          padding-left: 0.2rem;
                          >div {
                            display: flex;
                            align-items: center;
                            font-size: 0.26rem;
                            margin-bottom: .2rem;
                            color: #ffffff;
                          }
                      }
                  }
              }
              .is-active {
                  .el-collapse-item__header {
                      border: none;
                  }
                  .el-collapse-item__content {
                      border: none;
                  }
              }
          }
        }
        .mobile_footer_menu_middle {
          .mobile_footer_menu_middle_item {
            height: 1rem;
            display: flex;
            align-items: center;
            border-bottom: 1px solid #1f3d6c;
            font-size: 0.3rem;
          }
        }
        .mobile_footer_menu_contact {
          display: flex;
          align-items: center;
          margin-bottom: 0.4rem;
          .mobile_footer_menu_contact_left {
            margin-right: 1rem;
            .mobile_footer_menu_contact_top {
              font-size: 0.3rem;
              height: 1rem;
              display: flex;
              align-items: center;
            }
            .mobile_footer_menu_contact_middle {
              display: flex;
              align-items: center;
              margin-bottom: 0.2rem;
              .mobile_footer_menu_contact_middle_left {
                width: 0.4rem;
                height: 0.4rem;
                margin-right: 0.15rem;
                img {
                  width: 100%;
                  height: 100%;
                }
              }
              .mobile_footer_menu_contact_middle_right {
                font-size: 0.38rem;
              }
            }
            .mobile_footer_menu_contact_bottom {
              line-height: 1.5;
            }
          }
          .mobile_footer_menu_contact_right {
            display: flex;
            align-items: center;
            .mobile_footer_menu_contact_right_box {
              width: 1.8rem;
              height: 1.8rem;
              img {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
        .mobile_footer_menu_bottom {
          display: flex;
          flex-direction: column;
          justify-content: center;
          .mobile_footer_menu_bottom_item {
            line-height: 1.5;
          }
          .mobile_footer_menu_bottom_first {
            margin-bottom: .1rem;
          }
        }
      }
    }
  }
  .el-drawer__wrapper {
    .el-drawer__container {
      .el-drawer__body {
        .mobile_menu_box {
          width: 100%;
          height: 100%;
          padding: 0.3rem;
          .mobile_menu_box_top {
            i {
              font-size: 0.5rem;
            }
          }
          .mobile_menu_box_bottom {
            .mobile_menu_box_bottom_top {
              display: flex;
              .mobile_menu_box_bottom_top_item {
                height: 1rem;
                line-height: 1rem;
                font-size: 0.3rem;
              }
            }
            .mobile_menu_box_bottom_bottom {
              .menu_item {
                font-size: 0.28rem;
                height: 1rem;
                line-height: 1rem;
                border-bottom: 1px solid #e5e5e5;
              }
              .active {
                color: #0085D0;
              }
            }
          }
        }
      }
    }
  }
  @media (max-width: 768px) {
    .banner {
      width: 100%;
      .banner_box {
        width: 100%;
        .index_banner {
          height: 5rem;
          width: 100%;
          /deep/ .el-carousel {
            height: 5rem;
            .el-carousel__container {
                height: 5rem!important;
                .el-carousel__item {
                    height: 5rem;
                    img {
                        width: 100%;
                        height: 5rem;
                        object-fit: cover;
                    }
                }
            }
          }
        }
        .other_banner {
          height: 3rem;
          width: 100%;
          position: relative;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
          .other_banner_text {
            font-size: 0.5rem;
          }
        }
      }
    }

  }
}
</style>